import { render, staticRenderFns } from "./GameCharacter.vue?vue&type=template&id=6e968662"
import script from "./GameCharacter.vue?vue&type=script&lang=js"
export * from "./GameCharacter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports